import { ICompleteCheckSmsReqParams, IJoinRequestParams } from '@/core/domain/entities/request';
import { errorCodes } from '@/services/api/errorCodes';
import {
  completeCheckSms,
  getCountry,
  join,
  validateNicknameUniqueness,
  validatePhoneNumberUniqueness,
} from '@/services/api/UserApi';

export async function checkUniquePhoneNumber(
  phone: string,
): Promise<{ succed: boolean; errorProcceded?: boolean; errorMessage?: string }> {
  try {
    const ret = await validatePhoneNumberUniqueness(phone);
    const errorInfo = errorCodes.find((error) => error.code === ret);

    if (errorInfo) return { succed: false, errorProcceded: true, errorMessage: errorInfo.message };

    return { succed: true };
  } catch (error) {
    console.error(error);

    return { succed: false };
  }
}

export async function tryCompleteCheckSms(
  reqData: ICompleteCheckSmsReqParams,
): Promise<{ succed: boolean; errorProcceded?: boolean; errorMessage?: string }> {
  try {
    const ret = await completeCheckSms(reqData);
    const errorInfo = errorCodes.find((error) => error.code === ret);

    if (errorInfo) return { succed: false, errorProcceded: true, errorMessage: errorInfo.message };

    return { succed: true };
  } catch (error) {
    console.error(error);
    return { succed: false };
  }
}

export async function fetchCountry(): Promise<{ succed: boolean; errorProcceded?: boolean; errorMessage?: string }> {
  try {
    await getCountry();

    return { succed: true };
  } catch (error) {
    console.error(error);
    return { succed: false };
  }
}

export async function tryCheckUniqueNickname(
  name: string,
): Promise<{ succed: boolean; errorProcceded?: boolean; errorMessage?: string }> {
  try {
    const ret = await validateNicknameUniqueness(name);
    const errorInfo = errorCodes.find((error) => error.code === ret);

    if (errorInfo) return { succed: false, errorProcceded: true, errorMessage: errorInfo.message };

    return { succed: true };
  } catch (error) {
    console.error(error);
    return { succed: false };
  }
}

export async function tryJoin(
  reqData: IJoinRequestParams,
): Promise<{ succed: boolean; errorProcceded?: boolean; errorMessage?: string }> {
  try {
    const ret = await join(reqData);
    const errorInfo = errorCodes.find((error) => error.code === ret);

    if (errorInfo) return { succed: false, errorProcceded: true, errorMessage: errorInfo.message };

    return { succed: true };
  } catch (error) {
    console.error(error);
    return { succed: false };
  }
}
